import { render, staticRenderFns } from "./UnlockSuccess.vue?vue&type=template&id=22f9b72c&scoped=true&"
import script from "./UnlockSuccess.vue?vue&type=script&lang=js&"
export * from "./UnlockSuccess.vue?vue&type=script&lang=js&"
import style0 from "./UnlockSuccess.vue?vue&type=style&index=0&id=22f9b72c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9b72c",
  null
  
)

export default component.exports